type TranslationAlertProps = {
  isVisible: boolean
  onClose?: () => void
};

export const TranslationAlert = ({ isVisible }: TranslationAlertProps) => {
  if (!isVisible) return null;

  return (
    <>
      <div className="fixed inset-x-0 top-0 z-[9999] text-white shadow-xl bg-gradient-to-br from-[#81a3f8] to-[#5533ea] animate-[slideDownFromTop_0.4s_ease-out]">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-5 p-5 pt-6 pb-7">
          <div className="flex-1 space-y-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold">Traduction automatique détectée</h2>
            <p className="text-sm md:text-base opacity-90 text-pretty">
              La traduction automatique de Chrome peut causer des problèmes d'affichage sur notre site.
              Veuillez la désactiver pour une meilleure expérience.
              Une fois la traduction automatique désactivée, veuillez rafraîchir la page.
            </p>
          </div>

          <a
            href="https://support.google.com/chrome/answer/173424"
            target="_blank"
            rel="noopener noreferrer"
            className="text-center px-6 py-2 rounded-full font-semibold bg-white shadow-lg transform transition animate-heartbeat hover:scale-105 hover:shadow-xl"
          >
            <span className="bg-gradient-to-r from-[#464ee5] to-[#5533ea] bg-clip-text text-transparent">
              Comment désactiver la traduction ?
            </span>
          </a>
        </div>
      </div>

      <div className="fixed inset-0 bg-black opacity-40 w-full h-full z-[9998]" />
    </>
  );
};
